export default {
    inserted(el) {
        const triggerEl = el.querySelector('.el-table__header-wrapper');
        const dragDom = el.closest('.el-popover');
        if (!triggerEl || !dragDom) return;
        triggerEl.style.cursor = 'move';
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
        triggerEl.onmousedown = (e) => {
            if (e.target.tagName === 'BUTTON' || e.target.tagName === 'INPUT') return;
            const disX = e.clientX - triggerEl.getBoundingClientRect().left;
            const disY = e.clientY - triggerEl.getBoundingClientRect().top;

            let styL, styT;
            if (sty.left.includes('%')) {
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
            } else {
                styL = +sty.left.replace(/\px/g, '');
                styT = +sty.top.replace(/\px/g, '');
            }
            document.onmousemove = function (e) {
                let l = e.clientX - disX;
                let t = e.clientY - disY;
                const screenWidth = document.documentElement.clientWidth;
                const screenHeight = document.documentElement.clientHeight;
                const dragWidth = dragDom.offsetWidth;
                const dragHeight = dragDom.offsetHeight;

                if (l < 0) l = 0;
                if (l > screenWidth - dragWidth) l = screenWidth - dragWidth;
                if (t < 0) t = 0;
                if (t > screenHeight - dragHeight) t = screenHeight - dragHeight;

                dragDom.style.left = `${l}px`;
                dragDom.style.top = `${t}px`;
                dragDom.style.transform = 'none';
                dragDom.style.margin = '0';
            };
            document.onmouseup = function () {
                document.onmousemove = null;
                document.onmouseup = null;
            };
            return false;
        };
    }
}